// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vfKK","iconWrapper":"styles_iconWrapper__3N5f9"};